/*
 * decaffeinate suggestions:
 * DS103: Rewrite code to no longer use __guard__
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from "jquery";

import OkC from "shared/util/OkcApi";
import _str from "shared/util/_str";
import Analytics from "analytics/util/Analytics";
import ClientStats from "shared/util/ClientStats";
import Breadcrumb from "shared/util/Breadcrumb";
import { getStore } from "shared/redux/addToGlobalStore";
import {
	startBoost,
	endBoost,
	setBoostTokenCount,
	setBoostMultiplier,
} from "ducks/navbar";
import Context from "shared/util/Context";
import sourceFromPathname from "analytics/util/source";
import { BOOST_STATE } from "shared/constants/boosts";

const BoostController = {
	init(params) {
		// Shorties for my shorties
		this.Storage = BoostStorage;
		this.Model = BoostModel;
		this.Dom = BoostDom;
		this.View = BoostView;

		// get this started by initting the view, so it can start rendering
		this.Dom.init();
		this.View.init();
		this.Storage.init();
		this.Model.init(params);

		// simple, shitty way of tracking boosting source
		this.lastBoostInteraction = "";

		// continue process
		this.continuer = null;

		// form
		this.form = new OkForm(this.Dom.form_package.attr("id"));
		this.form.init();

		// Init the other controllers
		BoostViewers.init();
		BoostActivity.init();

		if ((this.Model.get("state") === BOOST_STATE.Running) && params.current_boost_params) {
			this.start(params.current_boost_params);
		}

		if (this.Model.get("openboosts") && !PageState.get("boostopened")) {
			PageState.set({ boostopened: true });
			this.openModal();
		}

		// if newly qualified for boosts, show the intro popover
		if (this.Model.get("showBoostIntroPopover") && !PageState.get('sawBoostPromo')) {
			if ((this.Dom.button_usernav_open != null ? this.Dom.button_usernav_open.length : undefined)) {
				this.initLimelight();
			} else {
				this.initPopover();
			}
		}

		this.listen();
	},


	listen() {
		this.Dom.button_open.on("click tap", ev => {
			ev.preventDefault();
			ev.stopPropagation();

			this.Model.set("showBoostSubs", false);

			// if the popover is open, then close it
			if (this.Model.get("showBoostIntroPopover")) {
				this.closePopover();
			}

			this.lastBoostInteraction = "desktop header button";

			return this.open();
		});

		this.Dom.button_usernav_open.on("click tap", ev => {
			this.lastBoostInteraction = "desktop user nav link";
			this.Model.set("showBoostSubs", false);
			this.open();
			(window.HeaderBarUserMenu != null ? window.HeaderBarUserMenu.close() : undefined);
		});

		this.Dom.button_buy.on("click tap", ev => {
			ev.preventDefault();
			this.buy();
		});

		this.Dom.button_close.on('click tap', ev => {
			ev.preventDefault();
			Modal.close();
		});

		this.Dom.button_closereport.on("click tap", ev => {
			ev.preventDefault();
			this.closeReport();
		});

		this.Dom.button_closeactivity.on("click tap", ev => {
			ev.preventDefault();
			this.closeReport();
		});

		this.Dom.button_boostagain.on("click tap", ev => {
			ev.preventDefault();
			this.lastBoostInteraction = "desktop boost again button";
			this.boostAgain();
		});

		this.Dom.button_cancel.on("click tap", ev => {
			ev.preventDefault();
			this.cancel();
		});

		this.Dom.tokenpackages.on("change", "input[type=radio]", ev => {
			ev.preventDefault();
			this.selectTokenPackage();
		});

		this.Dom.subpackages.on("change", "input[type=radio]", ev => {
			ev.preventDefault();
			this.selectSubPackage();
		});

		this.Dom.window.on("scroll resize", ev => {
			if (this.Model.get("isopen")) {
				this.positionPanel();
			}

			return true;
		});

		// pkg/sub toggler
		this.Dom.button_togglepkgs.on("click tap", ev => {
			this.Model.set("showBoostSubs", false);
			this.Model.set("activeSlide", 0);
		});

		this.Dom.button_togglesubs.on("click tap", ev => {
			boostsubs_controller.add_cf("modal_toggle");
			ClientStats.update("desktop - boostsubs - modal - toggled");

			this.Model.set("showBoostSubs", true);
			this.Model.set("activeSlide", 0);
		});

		// boost modal copy experiment has a carousel
		this.Dom.modal_slide.on("click tap", ev => {
			const slideIndex = $(ev.currentTarget).closest("button").attr("data-slide-index");
			this.Model.set("activeSlide", slideIndex);
		});

		// subs promo in the sidebar
		this.Dom.button_subspromo.on("click tap", ev => {
			ev.preventDefault();
			ev.stopPropagation();
			this.openToBoostSubs();
		});

		// boost sub confirmation
		this.Dom.modal_success.on("click tap", ".flatbutton.blue", ev => {
			ev.preventDefault();
			this.Model.set("showBoostSuccess", false);
			PageState.set({ sawBoostSuccess: true });
			Modal.close(this.Dom.modal_success.attr("id"));
		});


		// Rush hour modal actions, not always present
		if (this.Dom.rushhour_modal.length) {
			this.Dom.rushhour_promote.on('click tap', () => {
				this.lastBoostInteraction = "desktop rush hour modal";
				this.open();
				Modal.queue = [];
				window.util.updateStats('rush hour - modal promote me clicked', 1, 'counter', 'WWGsqXSF07PiYCFUVtwRYj3i/jQ=');
			});

			this.Dom.rushhour_close.on('click tap', () => {
				Modal.close('rush_hour_modal');
			});

			this.Dom.rushhour_modal.on('modalclose', () => {
				window.util.updateStats('rush hour - modal closed', 1, 'counter', 'vZsIMYrEeBHFNOloGVOLsml41XA=');
			});
		}


		// boost into popover
		if (this.Model.get("showBoostIntroPopover") && this.Dom.button_boost_intro_popover.length) {
			this.Dom.button_boost_intro_popover.on("click tap", ev => {
				ev.preventDefault();
				this.closePopover();

				// if there's a class for learn more, then open the boost menu
				if (this.Model.get("boostPopoverLearnMore")) {
					this.lastBoostInteraction = "desktop boost intro popover";
					this.open();
				}
			});
		}
	},


	// Boost intro popover
	// --------------------------------------------------------------------------
	initPopover() {
		const popover_config = {
			heading: "Boost yourself!",
			classes: "boost-popover-groovy",
			message:
				`${_str("Be seen by more people faster.")} \
${_str("Each Boost gets you a full day's")} \
${_str("worth of activity in 30 minutes.")}`,
			button: "Groovy",
			target: this.Dom.button_open,
		};

		if (this.Model.get("boostPopoverLearnMore")) {
			popover_config.button = "Learn more";
			popover_config.classes = "boost-popover-learn-more";
		}

		this.boost_intro_popover = new OkPopover({
			id: "nav-boost-intro-popover",
			classes: popover_config.classes,
			direction: "bottom",
			heading: popover_config.heading,
			message: popover_config.message,
			target: popover_config.target,
			padding: 22,
			buttons: [`<button class=\"flatbutton blue continue\">${popover_config.button}</button>`],
		});

		// add the button to the dom map
		this.Dom.button_boost_intro_popover = $('#nav-boost-intro-popover .continue');

		setTimeout(() => {
			ClientStats.update("desktop - boost intro - popover - opened");
			this.boost_intro_popover.open();
		}, this.Model.get("popoverdelay"));
	},

	closePopover() {
		if ((this.boost_intro_popover == null)) { return; }

		this.boost_intro_popover.close();
		this.Model.set("showBoostIntroPopover", false);

		// graduate the user
		userGuides.graduate('BOOST_INTRO_POPOVER');
		ClientStats.update("desktop - boost intro - popover - closed");

		// add cf tags for exp groups in case there's a purchase
		if (this.Model.get("boostPopoverLearnMore")) {
			if (typeof boostsubs_controller !== 'undefined' && boostsubs_controller !== null) {
				boostsubs_controller.add_cf("boost_tip_learn_more");
			}
		} else {
			if (typeof boostsubs_controller !== 'undefined' && boostsubs_controller !== null) {
				boostsubs_controller.add_cf("boost_tip_groovy");
			}
		}

		// Update the page state
		PageState.set({ sawBoostPromo: true });
	},


	// Same purpose as the popover, but for a different layout
	initLimelight() {
		const headerDelay = 300;
		const limelightDelay = 800;

		setTimeout(() => {
			HeaderBarUserMenu.open();
		}, headerDelay);

		setTimeout( () => {
			ClientStats.update("desktop - boost intro - limelight - opened");

			Limelight.open({
				target: this.Dom.button_usernav_open,
				size: 260,
				color: "teal",
				title: "Boost yourself!",
				body: `\
${_str("Be seen by more people faster.")}<br/>
${_str("Each boost gives you a full day's")}<br/>
${_str("activity in 30 minutes.")}\
`,
				cta: "Okay!",
				onClose: () => {
					// Mark as shown
					this.Model.set("showBoostIntroPopover", false);
					PageState.set({ sawBoostPromo: true });
					// Trigger server stuff
					userGuides.graduate('BOOST_INTRO_POPOVER');
					ClientStats.update("desktop - boost intro - limelight - closed");
				}
			});
		}, limelightDelay);
	},


	// Panel actions
	// --------------------------------------------------------------------------

	openToBoostSubs() {
		// this overrides the modal toggle cf; it eats the credit!
		boostsubs_controller.remove_cf("modal_toggle");
		boostsubs_controller.add_cf("panel_promo");
		ClientStats.update("desktop - boostsubs - panel - link clicked");

		if (this.Model.get("boostSubsGoAgain")) {
			boostsubs_controller.add_cf("panel_promo_goagain");
		} else if (this.Model.get("boostSubsPromoOnly")) {
			boostsubs_controller.add_cf("panel_promo_promoonly");
		}

		this.Model.set("showBoostSubs", true);
		this.closeReport();
		this.openModal();
	},

	open(cameFrom, promoDesign) {
		// Turn off the onboarding stuff if it's still up
		if (typeof HeaderBarOnboarding !== 'undefined' && HeaderBarOnboarding !== null ? HeaderBarOnboarding.initted : undefined) {
			if (HeaderBarOnboarding.popovers[HeaderBarOnboarding.current] != null) {
				HeaderBarOnboarding.popovers[HeaderBarOnboarding.current].close();
			}

			HeaderBarOnboarding.complete();
		}

		const state = this.Model.get("state");
		const tokenCount = this.Model.get("tokens");

		if (state === BOOST_STATE.NeedingTokens) {
			window.ReactBoosts.open({ cameFrom, promoDesign });
		} else if (state === BOOST_STATE.ReadyToActivate){
			this.spendToken();
			Modal.close();
		}
	},

	cancel() {
		OkC.delete("/boost/current", {
			api: 1,
			success: () => {
				this.finish();
			}
		})
			.then(() => {
				getStore().dispatch(endBoost());
				getStore().dispatch(setBoostTokenCount(this.Model.get("tokens")));
			})
	},

	openModal() {
		Modal.open(this.Dom.modal.attr("id"));
		this.selectTokenPackage();
		this.selectSubPackage();
		window.util.updateStats("desktop - boosts - opened modal", 1, "counter", "e3rKwkghfWNvd4ze8MfU6K0QVLY=");
	},

	positionPanel() {
		let paneltop;
		const pagetop = this.Dom.page.offset().top;
		const scrolltop = this.Dom.window.scrollTop();

		if (pagetop >= scrolltop) {
			paneltop = pagetop - scrolltop;
		} else if (scrolltop < 0) {
			paneltop = -scrolltop;
		} else {
			paneltop = 0;
		}

		if (paneltop !== this.paneltop) {
			this.Dom.panel.css("top", paneltop);
			this.paneltop = paneltop;
		}
	},


	// Token purchasing
	// --------------------------------------------------------------------------

	selectTokenPackage() {
		const radio = this.Dom.tokenpackages.find("input[type=radio]:checked");
		this.Model.set("tokenpackage", radio.val());
	},

	selectSubPackage() {
		const radio = this.Dom.subpackages.find("input[type=radio]:checked");
		this.Model.set("subpackage", radio.val());
	},

	buy() {
		if (this.Model.get("showBoostSubs")) {
			this.buySubs();
		} else {
			this.buyTokens();
		}
	},

	buyTokens() {
		// close the modal here
		Modal.close(this.Dom.modal.attr("id"));

		spotlight_controller.set_param('boostpkgs', this.Model.get("tokenpackage"));
		spotlight_controller.open();

		ClientStats.update({
			statname: "purchases - product:boost - option selected",
			skipDelay: true,
			unique: true
		});
	},

	buySubs() {
		// close the modal here
		Modal.close(this.Dom.modal.attr("id"));

		boostsubs_controller.set_param('planid', this.Model.get("subpackage"));
		boostsubs_controller.open();
	},

	spendToken() {
		// if for some reason they don't got tokens, make em pay
		if (!this.Model.get("tokens") || this.Model.get("activated") || this.adding) {
			return;
		}

		this.Model.set("confirming", true);
		this.adding = true;

		OkC.post("boost/start", {
			dataType: "json",
			version: 1,
		})
		.then((resp) => {
			const {
				numTokens,
				successinfo: { endtime, starttime },
			} = resp;
			const MILLISECONDS = 1000;

			getStore().dispatch(startBoost(endtime * MILLISECONDS, starttime * MILLISECONDS));
			getStore().dispatch(setBoostTokenCount(numTokens));

			this.spendToken_cb(resp);
		})
	},

	spendToken_cb(params) {
		this.adding = false;

		this.Model.set({
			tokens: params.numTokens,
			confirming: false
		});

		this.start(params.successinfo);

		Analytics.logUIEvent(
			Analytics.eventNames.boosted,
			{
				data: {
					source: sourceFromPathname(),
					"boost tokens remaining": params.numTokens,
					"came from": "boost.desktopnavbar",
				}
			}
		);
	},

	// Run on successful purchase
	validatePurchase(params) {
		if (!__guard__(params != null ? params.successinfo : undefined, x => x.newtokens)) {
			return;
		}

		this.Model.set({
			tokens: this.Model.get("tokens") + params.successinfo.newtokens,
			tokenpackage: "",
			confirming: true
		});

		// close the quickbuy box
		spotlight_controller.close();

		// spend the token right away (in a sec)
		setTimeout(() => {
			this.spendToken();
		}, 2000);
	},

	validateNewPurchase(tokens) {
		if (!tokens) {
			return;
		}

		this.Model.set({
			tokens: this.Model.get("tokens") + tokens,
			tokenpackage: "",
			confirming: true
		});

		// spend the token right away (in a sec)
		setTimeout(() => {
			this.spendToken();
		}, 2000);
	},

	// on successful subscription purchase
	validateSub(response) {
		boostsubs_controller.close();

		this.Model.set({
			hasBoostSub: true,
			showBoostSuccess: true,
			next_autoboost: __guard__(response != null ? response.successinfo : undefined, x => x.next_autoboost) || ""
		});

		PageState.set({ hasBoostSub: true });
	},

	// Attempt to redeem a free boost
	claimFreeBoost(cb) {
		OkC.post("/boost/claim", {
			api: 1
		})
		.then(res => {
			if (res.success) {
				this.Model.set({ tokens: this.Model.get("tokens") + 1 });
				this.spendToken();
				(typeof cb === 'function' ? cb() : undefined);
			} else {
				new Error();
			}
		})
		.catch(function(err) {
			if (typeof cb === 'function') {
				cb(err);
			}

			(typeof FeedbackBanner !== 'undefined' && FeedbackBanner !== null ? FeedbackBanner.open({
				message: _str("Unable to redeem free Boost, please contact support"),
				type: 'error',
				timeout: 3000
			}) : undefined);
		});
	},


	// Boosts
	// --------------------------------------------------------------------------

	// Start a fresh boost
	start(params) {
		this.Model.set(params);

		// open for good
		this.open();

		// turn off instant events rate limiter
		EventUiManager.m_should_wait = false;

		// sync stats automatically
		this.Model.autoSync();

		// get viewers started up
		BoostViewers.expand();

		// clear out any hidden activity
		BoostActivity.expand();

		this.continue();

		// position the panel when it starts
		this.positionPanel();
	},

	// Continue an existing boost
	continue() {
		if (this.killswitch) { return; }
		this.Model.updateCalculatedValues();

		// force a render, so the timestamp changes
		this.View.forceRender();

		// check if we should finish
		if (this.Model.get("left") <= 0) {
			this.finish();

		// otherwise, keep the loop goin
		} else {
			/*
				Use requestAnimationFrame for buttery smoothness
				(Elsewhere we shim that to setTimeout)
			*/
			window.requestAnimationFrame( () => {
				this.continue();
			});
		}
	},


	// Sew that shit up
	finish() {
		getStore().dispatch(endBoost());

		this.Model.stopSync();

		// close viewers
		BoostViewers.retract();

		// expand report
		BoostActivity.expand();

		this.Model.set({
			// the current promo id is now the last promo ids
			lastpromoid: this.Model.get("promoid"),

			// set viewers to the last impression count
			lastpromoimpressions: this.Model.get("viewers"),

			// clear running boost params
			promoid: 0,
			starttime: 0,
			endtime: 0,
			duration: 0,
			done: 0,
			percentage: 0,
			mins: "00",
			secs: "00",
			isbonus: false,
			activated: false,

			// set this session as a boosted one
			boosted: true
		});

		// run one last sync to get the latest imp count
		this.Model.sync();
	},

	closeReport() {
		this.Model.setReportSeen();
		this.Model.set({
			lastpromoid: 0,
			lastpromoimpressions: 0,
			lastpromoend: 0,
			autoboost_viewers: 0,
			autoboost_time: "",
			isautoboost: false
		});

		EventUiManager.clearNotifications();
	},

	boostAgain() {
		// ordinarily, closing a report will close the sidebar.
		// but we don't want to do that if we're just starting it back up again.
		// so set a stopper to force it open.

		this.closeReport();

		if (this.Model.get("tokens")) {
			this.Model.set("confirming", true);
			this.spendToken();
		} else {
			this.open();
		}
	},
};

window.BoostController = BoostController;
export default BoostController;

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}



// WEBPACK FOOTER //
// ./src/legacy/boosts/controller.js